const currencyKey = (businessUnitId) => `pilcore:pms:display-currency:${businessUnitId}`;
const rateSetKey = (businessUnitId) => `pilcore:pms:fx-rate-set:${businessUnitId}`;

export function readStoredDisplayCurrency(businessUnitId) {
  if (!businessUnitId) return "";
  return String(localStorage.getItem(currencyKey(businessUnitId)) || "").toUpperCase();
}

export function readStoredFxRateSetId(businessUnitId) {
  if (!businessUnitId) return "";
  return String(localStorage.getItem(rateSetKey(businessUnitId)) || "");
}

export function storeDisplayCurrency(businessUnitId, currencyCode, fxRateSetId) {
  if (!businessUnitId) return;
  const currency = String(currencyCode || "").toUpperCase();
  if (currency) localStorage.setItem(currencyKey(businessUnitId), currency);
  else localStorage.removeItem(currencyKey(businessUnitId));
  if (fxRateSetId) localStorage.setItem(rateSetKey(businessUnitId), String(fxRateSetId));
  else localStorage.removeItem(rateSetKey(businessUnitId));
}

export function resolveRequestBusinessUnitId(config = {}) {
  const fromParams = Number(config?.params?.business_unit_id || 0);
  if (fromParams) return fromParams;

  try {
    const configuredUrl = new URL(config.url || "", window.location.origin);
    const fromUrl = Number(configuredUrl.searchParams.get("business_unit_id") || 0);
    if (fromUrl) return fromUrl;
  } catch (_error) {
    // Relative or incomplete URLs fall through to the current PMS location.
  }

  const currentUrlBusinessUnit = Number(
    new URLSearchParams(window.location.search).get("business_unit_id") || 0
  );
  if (currentUrlBusinessUnit) return currentUrlBusinessUnit;

  try {
    const user = JSON.parse(localStorage.getItem("palantir_user") || "{}");
    return Number(user?.active_business_unit_id || 0) || null;
  } catch (_error) {
    return null;
  }
}
